// This script demonstrates access to the NFT API via the Alchemy SDK.
import {
  Network,
  Alchemy,
  Nft,
  OwnedNftsResponse,
  OwnedNft,
  AssetTransfersCategory,
  SortingOrder,
  AssetTransfersParams,
  AssetTransfersResponse,
} from 'alchemy-sdk';

// Optional Config object, but defaults to demo api-key and eth-mainnet.
// const settings = {
//   apiKey: process.env.REACT_APP_ALCHEMY_API_KEY!, // Replace with your Alchemy API Key.
//   network: process.env.NODE_ENV === 'production' ? Network.MATIC_MAINNET : Network.MATIC_AMOY, // Replace with your network.
// };

// const alchemy = new Alchemy(settings);

// // Print owner's wallet address:
// const ownerAddr = 'vitalik.eth';
// console.log('fetching NFTs for address:', ownerAddr);
// console.log('...');

// // Print total NFT count returned in the response:
// const nftsForOwner = await alchemy.nft.getNftsForOwner('vitalik.eth');
// console.log('number of NFTs found:', nftsForOwner.totalCount);
// console.log('...');

// // Print contract address and tokenId for each NFT:
// for (const nft of nftsForOwner.ownedNfts) {
//   console.log('===');
//   console.log('contract address:', nft.contract.address);
//   console.log('token ID:', nft.tokenId);
// }
// console.log('===');

// // Fetch metadata for a particular NFT:
// console.log('fetching metadata for a Crypto Coven NFT...');
// type ResNftMetadataProps = {
//   title: string;
//   tokenType: string;
//   tokenUri: any;
//   rawMetadata: any;
//   timeLastUpdated: string;
// };
// const response: Nft = await alchemy.nft.getNftMetadata('0x5180db8F5c931aaE63c74266b211F580155ecac8', '1590');

// Uncomment this line to see the full api response:
// console.log(response);

// Print some commonly used fields:
// console.log('NFT name: ', response.title);
// console.log('token type: ', response.tokenType);
// console.log('tokenUri: ', response.tokenUri.gateway);
// console.log('image url: ', response.rawMetadata.image);
// console.log('time last updated: ', response.timeLastUpdated);
// console.log('===');

type TxListType = {};
export default class AlchemyApi {
  private alchemy: Alchemy;
  constructor() {
    const settings = {
      apiKey: process.env.REACT_APP_ALCHEMY_API_KEY!, // Replace with your Alchemy API Key.
      network: process.env.NODE_ENV === 'production' ? Network.MATIC_MAINNET : Network.MATIC_AMOY, // Replace with your network.
      url:
        process.env.NODE_ENV === 'production'
          ? `https://polygon-mainnet.g.alchemy.com/v2/${process.env.REACT_APP_ALCHEMY_API_KEY!}`
          : `https://polygon-amoy.g.alchemy.com/v2/${process.env.REACT_APP_ALCHEMY_API_KEY!}`,
    };
    this.alchemy = new Alchemy(settings);
  }
  async nftsOwner(aAddr: string): Promise<OwnedNftsResponse> {
    // const re = await this.alchemy.nft.getNftsForOwner(aAddr);
    // // Parse output
    // const numNfts = re.totalCount;
    // const nftList = re.ownedNfts;

    // console.log(`Total NFTs owned by ${aAddr}: ${numNfts} \n`);
    // for (let i = 0; i < nftList.length; i++) {
    //   const element = nftList[i];
    //   console.log(`${i}. ${element.contract.name}`);
    // }

    // // 중복 이름 제거
    // const name = [...new Set(nftList)];
    // console.log(name);

    // let i = 1;
    // for (let nft of nftList) {
    //   console.log(`${i}. ${JSON.stringify(nft.contract.name)}`);
    //   i++;
    // }
    const res = await this.alchemy.nft.getNftsForOwner(aAddr);
    console.log(res);

    return res;
  }
  async nftMetadata(contractAddr: string, tokenId: string) {
    try {
      const re = await this.alchemy.nft.getNftMetadata(contractAddr, tokenId);
      return re;
    } catch (error) {
      console.log(error);
    }
  }
  async getTxHistory(aAddress: string, txType: 'from' | 'to', contractAddr?: string): Promise<AssetTransfersResponse> {
    let category;
    if (contractAddr) {
      category = [AssetTransfersCategory.ERC20];
    } else {
      category = [AssetTransfersCategory.EXTERNAL];
    }

    const payload: AssetTransfersParams = {
      fromBlock: '0x0',
      toBlock: 'latest',
      excludeZeroValue: true,
      withMetadata: true,
      category: category,
      order: SortingOrder.DESCENDING,
    };
    // if (txType === 'from') {
    //   payload.fromAddress = aAddress;
    // } else if (txType === 'to') {
    //   payload.toAddress = aAddress;
    // }
    txType === 'from' ? (payload.fromAddress = aAddress) : (payload.toAddress = aAddress);
    if (contractAddr) {
      payload.contractAddresses = [contractAddr];
    }

    const res = await this.alchemy.core.getAssetTransfers(payload);
    return res;
  }
  // async txFromList(aAddress: string, contractAddr: string) {
  //   const res = await this.alchemy.core.getAssetTransfers({
  //     fromBlock: '0x0',
  //     toBlock: 'latest',
  //     fromAddress: aAddress,
  //     // toAddress: toAddress,
  //     excludeZeroValue: true,
  //     contractAddresses: [contractAddr],
  //     category: [AssetTransfersCategory.ERC20],
  //     order: SortingOrder.DESCENDING,
  //   });
  //   console.log(res);
  // }
  // async txToList(aAddress: string, contractAddr: string) {
  //   const res = await this.alchemy.core.getAssetTransfers({
  //     fromBlock: '0x0',
  //     toBlock: 'latest',
  //     // fromAddress: aAddress,
  //     toAddress: aAddress,
  //     excludeZeroValue: true,
  //     contractAddresses: [contractAddr],
  //     category: [AssetTransfersCategory.ERC20],
  //     order: SortingOrder.DESCENDING,
  //   });
  //   console.log(res);
  // }
}
